import { DataProvider, DeleteOneParams } from "@refinedev/core";
import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";
import qs from "qs";

import axAPI from "../../../api/axios-instance";
import { generateFilter } from "../../../helpers";

const PLAYER_AWARDS_URL = "/cms/awards/player";

type PlayerAwardsMeta = {
  playerSlug?: string | null;
};

type PlayerAwardsCreateVars = {
  // id награды (players_award_items.id)
  awardId: number | string;
};

export const playerAwardsDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    getList: async ({ filters }) => {
      const queryFilters = generateFilter(filters);

      try {
        const { data } = await httpClient.get(PLAYER_AWARDS_URL, {
          params: queryFilters,
          paramsSerializer: (params) => qs.stringify(params),
        });

        // API response: List<{ playerSlug: string, awards: Award[] }>
        const awards = (() => {
          if (Array.isArray(data)) {
            const requestedSlug = queryFilters?.playerSlug;
            const match = requestedSlug
              ? data.find((v) => v?.playerSlug === requestedSlug)
              : data[0];
            return match?.awards ?? match?.rewards ?? [];
          }

          return data?.awards ?? data?.rewards ?? [];
        })();

        return {
          data: awards,
          total: Array.isArray(awards) ? awards.length : 0,
        };
      } catch (error: unknown) {
        return Promise.reject(error);
      }
    },
    create: async ({ variables, meta }) => {
      const { playerSlug } = (meta ?? {}) as PlayerAwardsMeta;
      const { awardId } = variables as PlayerAwardsCreateVars;

      try {
        const { data } = await httpClient.post(PLAYER_AWARDS_URL, {
          awardId: Number(awardId),
          playerSlug: playerSlug ?? null,
        });

        return { data };
      } catch (error: unknown) {
        return Promise.reject(error);
      }
    },
    deleteOne: async ({ id, meta }: DeleteOneParams) => {
      const { playerSlug } = (meta ?? {}) as PlayerAwardsMeta;

      try {
        const { data } = await httpClient.delete(PLAYER_AWARDS_URL, {
          // awardId в DELETE = rewardId награды, не id типа
          params: {
            awardId: Number(id),
            playerSlug: playerSlug ?? null,
          },
        });
        return { data };
      } catch (error: unknown) {
        return Promise.reject(error);
      }
    },
  };
